import { render, staticRenderFns } from "./IIcon.vue?vue&type=template&id=4a40690d&scoped=true&"
import script from "./IIcon.vue?vue&type=script&lang=js&"
export * from "./IIcon.vue?vue&type=script&lang=js&"
import style0 from "./IIcon.vue?vue&type=style&index=0&id=4a40690d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a40690d",
  null
  
)

export default component.exports